export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3" data-testid="brand-logo">
      <svg width="36" height="36" viewBox="0 0 100 100" fill="none" aria-hidden="true">
        <path d="M22 82V46a28 28 0 0 1 56 0v36" stroke="#B69B7D" strokeWidth="4" strokeLinecap="round" />
        <path d="M39 82V58a11 11 0 0 1 22 0v24" stroke="#F5F5F0" strokeWidth="3" strokeLinecap="round" />
        <line x1="13" y1="82" x2="87" y2="82" stroke="#B69B7D" strokeWidth="4" strokeLinecap="round" />
      </svg>
      {!compact && (
        <span className="leading-none">
          <span className="block font-serif text-xl tracking-wide text-foreground">
            AB <span className="italic text-primary">fëlise</span>
          </span>
          <span className="block text-[10px] uppercase tracking-[0.4em] text-muted-foreground mt-1">
            shop
          </span>
        </span>
      )}
    </span>
  );
}
